import React, { lazy, Suspense } from 'react';

const LazyOrderHistoryPrintedMaterials = lazy(() => import('./OrderHistoryPrintedMaterials'));

const OrderHistoryPrintedMaterials = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyOrderHistoryPrintedMaterials {...props} />
  </Suspense>
);

export default OrderHistoryPrintedMaterials;
